export default {
  'beijing': {
    '2022': {
      '职位分布': {
        'mainTitle': '学员职位分布',
        'subTitle': '数据截止 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '124',
            'intro': '任职公司 CTO'
          },
          {
            'number': '35',
            'intro': '任职公司 CEO'
          },
          {
            'number': '34',
            'intro': '任职技术 VP'
          },
          {
            'number': '87',
            'intro': '任职技术总监'
          },
          {
            'number': '194',
            'intro': '任职其他高管'
          }
        ]
      },
      // '团队规模'
      '学费收支': {
        'mainTitle': '截止 2022 年 12 月 31 日 北京收支情况',
        'subTitle': '2022 年 1 月 1 日 - 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '1,761,045',
            'intro': '学费收入（元）'
          },
          {
            'number': '1,056,627',
            'intro': '分会可用收入（元）'
          },
          {
            'number': '1,209,904.65 ',
            'intro': '活动支出（元）'
          },
          {
            'number': '203,171.69',
            'intro': '分会日常（元）'
          },
          {
            'number': '-356,449.34',
            'intro': '学费结余（元）'
          }
        ],
        'remark': '备注：费用不包含分会赞助费用'
      },
      '支出明细': {
        'mainData': [
          {
            'time': '2022年5月7日',
            'activity': 'TGO北京5月议桌局活动_2022',
            'expend': '￥3,577.27',
            'link': 'https://tgo.infoq.cn/event/513'
          },
          {
            'time': '2022年7月24日',
            'activity': 'TGO鲲鹏会北京7月活动_2022',
            'expend': '￥56,036.88',
            'link': 'https://tgo.infoq.cn/event/556'
          },
          {
            'time': '2022年8月5日',
            'activity': 'TGO北京8月走进京东活动_2022',
            'expend': '￥20,597.96',
            'link': 'https://tgo.infoq.cn/event/561'
          },
          {
            'time': '2022年8月26日',
            'activity': 'GTLC北京站_2022',
            'expend': '￥1,064,041.94',
            'link': 'https://tgo.infoq.cn/event/563'
          },
          {
            'time': '2022年9月29日',
            'activity': '走进中科宇航—TGO北京9月活动_2022',
            'expend': '￥2,031.32',
            'link': 'https://tgo.infoq.cn/event/354'
          },
          {
            'time': '/',
            'activity': 'TGO 北京分会日常费用_2022',
            'expend': '￥203,171.69',
            'link': '/'
          }
        ]
      }
    }
  },
  'shanghai': {
    '2022': {
      '职位分布': {
        'mainTitle': '学员职位分布',
        'subTitle': '数据截止 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '96',
            'intro': '任职公司 CTO'
          },
          {
            'number': '26',
            'intro': '任职公司 CEO'
          },
          {
            'number': '22',
            'intro': '任职技术 VP'
          },
          {
            'number': '56',
            'intro': '任职技术总监'
          },
          {
            'number': '180',
            'intro': '任职其他高管'
          }
        ]
      },
      // '团队规模'
      '学费收支': {
        'mainTitle': '截止 2022 年 12 月 31 日 上海收支情况',
        'subTitle': '2022 年 1 月 1 日 - 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '1,444,782',
            'intro': '学费总收入（元）'
          },
          {
            'number': '866,869.2',
            'intro': '分会可用收入（元）'
          },
          {
            'number': '582,512.36 ',
            'intro': '活动支出（元）'
          },
          {
            'number': '275,033.4',
            'intro': '分会日常（元）'
          },
          {
            'number': '9,323.44',
            'intro': '学费结余（元）'
          }
          // {
          //   'number': '',
          //   'intro': '赞助结余（元）'
          // }
        ],
        'remark': '备注：费用不包含分会赞助费用'
      },
      '支出明细': {
        'mainData': [
          {
            'time': '2022年1月9日',
            'activity': 'TGO上海分会年度家宴_2021',
            'expend': '￥124,267.82',
            'link': 'https://tgo.infoq.cn/event/254'
          },
          {
            'time': '2022年7月31日',
            'activity': 'TGO鲲鹏会上海7月培训活动_2022',
            'expend': '￥109,008.5',
            'link': 'https://tgo.infoq.cn/event/559'
          },
          {
            'time': '2022年8月30日',
            'activity': 'TGO鲲鹏会上海8月活动_2022',
            'expend': '￥30,687.4',
            'link': 'https://tgo.infoq.cn/event/583'
          },
          {
            'time': '2022年9月3日',
            'activity': 'TGO鲲鹏会上海9月演讲培训_2022',
            'expend': '￥23,288.4',
            'link': 'https://tgo.infoq.cn/event/588'
          },
          {
            'time': '2022年9月25日',
            'activity': 'GTLC上海站_2022',
            'expend': '￥211,479.3',
            'link': 'https://tgo.infoq.cn/event/593'
          },
          {
            'time': '2022年11月12日',
            'activity': 'TGO上海11月心理学课程_2022',
            'expend': '￥30,572.0',
            'link': 'https://tgo.infoq.cn/event/669'
          },
          {
            'time': '2022年11月20日',
            'activity': 'TGO上海11月组长培训_2022',
            'expend': '￥33,960.0',
            'link': 'https://tgo.infoq.cn/event/655'
          },
          {
            'time': '2022年12月11日',
            'activity': 'TGO上海12月创业营_2022',
            'expend': '￥19,249.0',
            'link': 'https://tgo.infoq.cn/event/692'
          },
          {
            'time': '/',
            'activity': 'TGO 上海分会日常费用_2022',
            'expend': '￥275,033.4',
            'link': '/'
          }
        ]
      }
    }
  },
  'nanjing': {
    '2022': {
      '职位分布': {
        'mainTitle': '学员职位分布',
        'subTitle': '数据截止 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '22',
            'intro': '任职公司 CTO'
          },
          {
            'number': '6',
            'intro': '任职公司 CEO'
          },
          {
            'number': '6',
            'intro': '任职技术 VP'
          },
          {
            'number': '11',
            'intro': '任职技术总监'
          },
          {
            'number': '41',
            'intro': '任职其他高管'
          }
        ]
      },
      // '团队规模'
      '学费收支': {
        'mainTitle': '截止 2022 年 12 月 31 日 南京收支情况',
        'subTitle': '2022 年 1 月 1 日 - 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '287,123',
            'intro': '学费收入（元）'
          },
          {
            'number': '172,273.8',
            'intro': '分会可用收入（元）'
          },
          {
            'number': '207,997.2',
            'intro': '活动支出（元）'
          },
          {
            'number': '35,795.02',
            'intro': '分会日常（元）'
          },
          {
            'number': '38,886',
            'intro': '日常（元）'
          },
          {
            'number': '-71,518.42',
            'intro': '学费结余（元）'
          }
        ],
        'remark': '备注：费用不包含分会赞助费用'
      },
      '支出明细': {
        'mainData': [
          {
            'time': '2021年12月12日',
            'activity': 'TGO南京分会年度家宴_2021',
            'expend': '￥4,408',
            'link': 'https://tgo.infoq.cn/event/411'
          },
          {
            'time': '2022年3月13日',
            'activity': 'TGO鲲鹏会南京3月活动_2022',
            'expend': '￥1,028',
            'link': 'https://tgo.infoq.cn/event/466'
          },
          {
            'time': '2022年5月17日',
            'activity': 'TGO鲲鹏会南京5月活动_2022',
            'expend': '￥39,837.88',
            'link': '/'
          },
          {
            'time': '2022年6月19日',
            'activity': '线下大课—TGO南京6月活动',
            'expend': '￥36,189.56',
            'link': 'https://tgo.infoq.cn/event/537'
          },
          {
            'time': '2022年7月16日',
            'activity': 'GTLC南京站_2022',
            'expend': '￥126,533.76',
            'link': 'https://tgo.infoq.cn/event/683'
          },
          {
            'time': '/',
            'activity': 'TGO 南京分会日常费用_2022',
            'expend': '￥35,795.02',
            'link': '/'
          }
        ]
      }
    }
  },
  'suzhou': {
    '2022': {
      '职位分布': {
        'mainTitle': '学员职位分布',
        'subTitle': '数据截止 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '5',
            'intro': '任职公司 CTO'
          },
          {
            'number': '1',
            'intro': '任职公司 CEO'
          },
          {
            'number': '0',
            'intro': '任职技术 VP'
          },
          {
            'number': '4',
            'intro': '任职技术总监'
          },
          {
            'number': '10',
            'intro': '任职其他高管'
          }
        ]
      },
      // '团队规模'
      '学费收支': {
        'mainTitle': '截止 2022 年 12 月 31 日 苏州收支情况',
        'subTitle': '2022 年 1 月 1 日 - 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '107,100',
            'intro': '学费总收入（元）'
          },
          {
            'number': '64,260',
            'intro': '分会可用收入（元）'
          },
          {
            'number': '5,889',
            'intro': '活动支出（元）'
          },
          {
            'number': '16,032.25',
            'intro': '分会日常（元）'
          },
          {
            'number': '42,338.75',
            'intro': '学费结余（元）'
          }
        ],
        'remark': '备注：费用不包含分会赞助费用'
      },
      '支出明细': {
        'mainData': [
          {
            'time': '2022年7月2日',
            'activity': 'TGO苏州7月活动_2022',
            'expend': '￥5,889.00',
            'link': 'https://tgo.infoq.cn/event/667'
          },
          {
            'time': '/',
            'activity': 'TGO 苏州分会日常费用_2022',
            'expend': '￥16,032.25',
            'link': '/'
          }
        ]
      }
    }
  },
  'chengdu': {
    '2022': {
      '职位分布': {
        'mainTitle': '学员职位分布',
        'subTitle': '数据截止 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '19',
            'intro': '任职公司 CTO'
          },
          {
            'number': '6',
            'intro': '任职公司 CEO'
          },
          {
            'number': '4',
            'intro': '任职技术 VP'
          },
          {
            'number': '18',
            'intro': '任职技术总监'
          },
          {
            'number': '50',
            'intro': '任职其他高管'
          }
        ]

      },
      // '团队规模'
      '学费收支': {
        'mainTitle': '截止 2022 年 12 月 31 日 成都收支情况',
        'subTitle': '2022 年 1 月 1 日 - 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '362,618',
            'intro': '学费总收入（元）'
          },
          {
            'number': '217,570.8',
            'intro': '分会可用收入（元）'
          },
          {
            'number': '210,748.64',
            'intro': '活动支出（元）'
          },
          {
            'number': '18,527.2',
            'intro': '分会日常（元）'
          },
          {
            'number': '-11,705.04',
            'intro': '学费结余（元）'
          }
        ],
        'remark': '备注：费用不包含分会赞助费用'
      },
      '支出明细': {
        'mainData': [
          {
            'time': '2022年1月8日',
            'activity': 'TGO成都分会年度家宴_2021',
            'expend': '￥101,452.98',
            'link': 'https://tgo.infoq.cn/event/415'
          },
          {
            'time': '2022年3月19日',
            'activity': 'TGO鲲鹏会成都3月活动_2022',
            'expend': '￥17,794.89',
            'link': 'https://tgo.infoq.cn/event/475'
          },
          {
            'time': '2022年4月28日',
            'activity': 'TGO鲲鹏会成都4月活动_2022',
            'expend': '￥2,602',
            'link': 'https://tgo.infoq.cn/event/512'
          },
          {
            'time': '2022年5月28日',
            'activity': 'TGO鲲鹏会成都5月活动_2022',
            'expend': '￥21,166',
            'link': 'https://tgo.infoq.cn/event/521'
          },
          {
            'time': '2022年6月26日',
            'activity': 'TGO鲲鹏会成都6月活动_2022',
            'expend': '￥14,026',
            'link': 'https://tgo.infoq.cn/event/541'
          },
          {
            'time': '2022年7月10日',
            'activity': 'TGO鲲鹏会成都7月活动_2022',
            'expend': '￥53,706.77',
            'link': 'https://tgo.infoq.cn/event/552'
          },
          {
            'time': '/',
            'activity': 'TGO 成都分会日常费用_2022',
            'expend': '￥18,527.2',
            'link': '/'
          }
        ]
      }
    }
  },
  'hangzhou': {
    '2022': {
      '职位分布': {
        'mainTitle': '学员职位分布',
        'subTitle': '数据截止 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '66',
            'intro': '任职公司 CTO'
          },
          {
            'number': '14',
            'intro': '任职公司 CEO'
          },
          {
            'number': '7',
            'intro': '任职技术 VP'
          },
          {
            'number': '28',
            'intro': '任职技术总监'
          },
          {
            'number': '56',
            'intro': '任职其他高管'
          }
        ]
      },
      // '团队规模'
      '学费收支': {
        'mainTitle': '截止 2022 年 12 月 31 日 杭州收支情况',
        'subTitle': '2022 年 1 月 1 日 - 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '517,650',
            'intro': '学费总收入（元）'
          },
          {
            'number': '310,590',
            'intro': '分会可用收入（元）'
          },
          {
            'number': '155,761.28',
            'intro': '活动支出（元）'
          },
          {
            'number': '62,885.72',
            'intro': '分会日常（元）'
          },
          {
            'number': '91,943',
            'intro': '学费结余（元）'
          }
        ],
        'remark': '备注：费用不包含分会赞助费用'
      },
      '支出明细': {
        'mainData': [
          {
            'time': '2022年1月9日',
            'activity': 'TGO鲲鹏会杭州分会年度家宴',
            'expend': '￥46,257.25',
            'link': 'https://tgo.infoq.cn/event/417'
          },
          {
            'time': '2022年5月21日',
            'activity': 'TGO杭州老爸去哪儿第四季_2022',
            'expend': '￥12,083.55',
            'link': 'https://tgo.infoq.cn/event/517'
          },
          {
            'time': '2022年5月29日',
            'activity': '大课-TGO杭州5月_2022',
            'expend': '￥30,683.28',
            'link': 'https://tgo.infoq.cn/event/523'
          },
          {
            'time': '2022年7月29日',
            'activity': 'TGO杭州六周年庆_2022',
            'expend': '￥29,578.21',
            'link': 'https://tgo.infoq.cn/event/554'
          },
          {
            'time': '2022年7月29日',
            'activity': 'TGO鲲鹏会杭州六周年庆和走进钉钉_2022',
            'expend': '￥37,158.99',
            'link': 'https://tgo.infoq.cn/event/555'
          },
          {
            'time': '/',
            'activity': 'TGO 杭州分会日常费用_2022',
            'expend': '￥62,885.72',
            'link': '/'
          }
        ]
      }
    }
  },
  'xiamen': {
    '2022': {
      '职位分布': {
        'mainTitle': '学员职位分布',
        'subTitle': '数据截止 2022 年 12月 31 日',
        'dataList': [
          {
            'number': '8',
            'intro': '任职公司 CTO'
          },
          {
            'number': '1',
            'intro': '任职公司 CEO'
          },
          {
            'number': '4',
            'intro': '任职技术 VP'
          },
          {
            'number': '13',
            'intro': '任职技术总监'
          },
          {
            'number': '28',
            'intro': '任职其他高管'
          }
        ]
      },
      // '团队规模'
      '学费收支': {
        'mainTitle': '截止 2022 年 12月 31 日 厦门收支情况',
        'subTitle': '2022 年 1 月 1 日 - 2022 年 12月 31 日',
        'dataList': [
          {
            'number': '287,000',
            'intro': '学费总收入（元）'
          },
          {
            'number': '172,200',
            'intro': '分会可用收入（元）'
          },
          {
            'number': '96,906.43',
            'intro': '活动支出（元）'
          },
          {
            'number': '68,896.88',
            'intro': '分会日常（元）'
          },
          {
            'number': '6,396.69',
            'intro': '学费结余（元）'
          }
        ],
        'remark': '备注：费用不包含分会赞助费用'
      },
      '支出明细': {
        'mainData': [
          {
            'time': '2021年12月4日',
            'activity': 'GTLC 技术领导力大会 厦门站_2021',
            'expend': '￥21,458.2',
            'link': 'https://gtlc.infoq.cn/2021/xiamen'
          },
          {
            'time': '2022年2月19日',
            'activity': '坦诚相见，虎年温泉之旅——TGO 厦门 2 月分会活动_2022',
            'expend': '￥5,715.61',
            'link': 'https://tgo.infoq.cn/event/462'
          },
          {
            'time': '2022年4月16日',
            'activity': '山谷里亲子漫时光——TGO 厦门 4 月分会活动_2022',
            'expend': '￥8,868.69',
            'link': 'https://tgo.infoq.cn/event/500'
          },
          {
            'time': '2022年6月12日',
            'activity': '敏捷团队绩效管理——TGO 厦门 6 月分会活动_2022',
            'expend': '￥6,089.7',
            'link': 'https://tgo.infoq.cn/event/535'
          },
          {
            'time': '2022年7月31日',
            'activity': '转型 ToB 领域的思考和选择框架——TGO 厦门 7 月分会活动_2022',
            'expend': '￥1,303.87',
            'link': 'https://tgo.infoq.cn/event/558'
          },
          {
            'time': '2022年9月3日',
            'activity': '中秋博饼活动——TGO 厦门 8 月分会活动_2022',
            'expend': '￥19,864.84',
            'link': 'https://tgo.infoq.cn/event/571'
          },
          {
            'time': '2022年10月26日',
            'activity': '如何打造高执行力技术团队——TGO 厦门 10 月分会活动_2022',
            'expend': '￥540.6',
            'link': 'https://tgo.infoq.cn/event/643'
          },
          {
            'time': '2022年12月10日',
            'activity': 'TGO 厦门年度家宴_2022',
            'expend': '￥1,724.42',
            'link': 'https://tgo.infoq.cn/event/691'
          },
          {
            'time': '/',
            'activity': 'TGO 厦门分会十全十美小组费用_2022',
            'expend': '￥20,000',
            'link': '/'
          },
          {
            'time': '/',
            'activity': 'TGO 厦门分会兴趣小组费用_2022',
            'expend': '￥148',
            'link': '/'
          },
          {
            'time': '/',
            'activity': 'TGO 厦门分会董事会费用_2022',
            'expend': '￥11,192.5',
            'link': '/'
          },
          {
            'time': '/',
            'activity': 'TGO 厦门分会日常费用_2022',
            'expend': '￥68,896.88',
            'link': '/'
          }
        ]
      }
    }
  },
  'shenzhen': {
    '2022': {
      '职位分布': {
        'mainTitle': '学员职位分布',
        'subTitle': '数据截止 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '48',
            'intro': '任职公司 CTO'
          },
          {
            'number': '18',
            'intro': '任职公司 CEO'
          },
          {
            'number': '7',
            'intro': '任职技术 VP'
          },
          {
            'number': '36',
            'intro': '任职技术总监'
          },
          {
            'number': '82',
            'intro': '任职其他高管'
          }
        ]
      },
      // '团队规模'
      '学费收支': {
        'mainTitle': '截止 2022 年 12 月 31 日 深圳收支情况',
        'subTitle': '2022 年 1 月 1 日 - 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '694,851',
            'intro': '学费总收入（元）'
          },
          {
            'number': '416,910.6',
            'intro': '分会可用收入（元）'
          },
          {
            'number': '103,032.52',
            'intro': '活动支出（元）'
          },
          {
            'number': '12,749.58',
            'intro': '分会日常（元）'
          },
          {
            'number': '301,128.5',
            'intro': '学费结余（元）'
          }
        ],
        'remark': '备注：费用不包含分会赞助费用'
      },
      '支出明细': {
        'mainData': [
          {
            'time': '2021年12月26日',
            'activity': 'TGO 深圳年度家宴_2021',
            'expend': '￥39,450',
            'link': 'https://tgo.infoq.cn/event/418'
          },
          {
            'time': '2021年10月22日-24日',
            'activity': 'GTLC 深圳大湾区高峰论坛_2021',
            'expend': '￥8,496.72',
            'link': 'https://gtlc.infoq.cn/2021/dawanqu/'
          },
          {
            'time': '2022年4月28日',
            'activity': '议桌局：乘风破浪，出海 ERP 如何危中寻机——TGO 深圳 4 月分会活动_2022',
            'expend': '￥2,668',
            'link': 'https://tgo.infoq.cn/event/504'
          },
          {
            'time': '2022年5月28日',
            'activity': '走进企业·深圳第 2 场-走进 AfterShip——TGO 深圳 5 月分会活动_2022',
            'expend': '￥4,010',
            'link': 'https://tgo.infoq.cn/event/514'
          },
          {
            'time': '2022年6月5日',
            'activity': '全天培训：商业创新诊断工作坊——TGO 深圳 6 月分会活动_2022',
            'expend': '￥18,909.8',
            'link': 'https://tgo.infoq.cn/event/533'
          },
          {
            'time': '2022年6月25日',
            'activity': '全天培训：企业投融资与决策——TGO 深圳 6 月系列大课_2022',
            'expend': '￥3,896',
            'link': 'https://tgo.infoq.cn/event/540'
          },
          {
            'time': '2022年11月29日',
            'activity': '议桌局：重回技术招聘本质——TGO 深圳 11 月议桌局_2022',
            'expend': '￥1,365',
            'link': 'https://tgo.infoq.cn/event/678'
          },
          {
            'time': '/',
            'activity': 'TGO 深圳分会十全十美小组费用_2022',
            'expend': '￥16,000',
            'link': '/'
          },
          {
            'time': '/',
            'activity': 'TGO 深圳分会董事会费用_2022',
            'expend': '￥4,401',
            'link': '/'
          },
          {
            'time': '/',
            'activity': 'TGO 深圳分会饭团费用_2022',
            'expend': '￥3,836',
            'link': '/'
          },
          {
            'time': '/',
            'activity': 'TGO 深圳分会日常费用_2022',
            'expend': '￥12,749.58',
            'link': '/'
          }
        ]
      }
    }
  },
  'wuhan': {
    '2022': {
      '职位分布': {
        'mainTitle': '学员职位分布',
        'subTitle': '数据截止 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '10',
            'intro': '任职公司 CTO'
          },
          {
            'number': '1',
            'intro': '任职公司 CEO'
          },
          {
            'number': '0',
            'intro': '任职技术 VP'
          },
          {
            'number': '9',
            'intro': '任职技术总监'
          },
          {
            'number': '17',
            'intro': '任职其他高层'
          }
        ]
      },
      // '团队规模'
      '学费收支': {
        'mainTitle': '截止 2022 年 12 月 31 日 武汉收支情况',
        'subTitle': '2022 年 1 月 1 日 - 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '178,880',
            'intro': '学费收入（元）'
          },
          {
            'number': '107,328',
            'intro': '分会可用收入（元）'
          },
          {
            'number': '17,664.68 ',
            'intro': '活动支出（元）'
          },
          {
            'number': '29,949.5',
            'intro': '分会日常（元）'
          },
          {
            'number': '59,713.82',
            'intro': '学费结余（元）'
          }
          // {
          //   'number': '',
          //   'intro': '赞助结余（元）'
          // }
        ],
        'remark': '备注：费用不包含分会赞助费用'
      },
      '支出明细': {
        'mainData': [
          {
            'time': '2021年12月26日',
            'activity': 'TGO武汉分会年度家宴_2021',
            'expend': '￥2,122',
            'link': 'https://tgo.infoq.cn/event/419'
          },
          {
            'time': '2022年6月26日 ',
            'activity': 'TGO武汉6月活动_2022',
            'expend': '￥15,542.68',
            'link': 'https://tgo.infoq.cn/event/538'
          },
          {
            'time': '/',
            'activity': 'TGO 武汉分会日常费用_2022',
            'expend': '￥29,949.5',
            'link': '/'
          }
        ]
      }
    }
  },
  'guangzhou': {
    '2022': {
      '职位分布': {
        'mainTitle': '学员职位分布',
        'subTitle': '数据截止 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '37',
            'intro': '任职公司 CTO'
          },
          {
            'number': '15',
            'intro': '任职公司 CEO'
          },
          {
            'number': '6',
            'intro': '任职技术 VP'
          },
          {
            'number': '21',
            'intro': '任职技术总监'
          },
          {
            'number': '65',
            'intro': '任职其他高管'
          }
        ]
      },
      // '团队规模'
      '学费收支': {
        'mainTitle': '截止 2022 年 12 月 31 日 广州收支情况',
        'subTitle': '2022 年 1 月 1 日 - 2022 年 12 月 31 日',
        'dataList': [
          {
            'number': '724,993',
            'intro': '学费收入（元）'
          },
          {
            'number': '434,995',
            'intro': '分会可用收入（元）'
          },
          {
            'number': '189,958.89',
            'intro': '活动支出（元）'
          },
          {
            'number': '38,137.3',
            'intro': '分会日常（元）'
          },
          {
            'number': '206,898.81',
            'intro': '学费结余（元））'
          }
          // {
          //   'number': '',
          //   'intro': '赞助结余（元）'
          // }
        ],
        'remark': '备注：费用不包含分会赞助费用'
      },
      '支出明细': {
        'mainData': [
          {
            'time': '2021年8月21日',
            'activity': '走近艺术，漫步算法公园——TGO 广州 8 月活动_2021',
            'expend': '￥3,500',
            'link': 'https://tgo.infoq.cn/event/343'
          },
          {
            'time': '2021年12月11日',
            'activity': 'TGO 广州年度家宴_2021',
            'expend': '￥898.2',
            'link': 'https://tgo.infoq.cn/event/414'
          },
          {
            'time': '2022年5月21日',
            'activity': '全天培训：To B 创新增长方法论——TGO 广州 5 月活动_2022',
            'expend': '￥47,495.5',
            'link': 'https://tgo.infoq.cn/event/516'
          },
          {
            'time': '2022年6月12日',
            'activity': '全天培训：博弈论与决策思维——TGO 广州 6 月分会活动_2022',
            'expend': '￥31,529.04',
            'link': 'https://tgo.infoq.cn/event/534'
          },
          {
            'time': '2021年8月21日',
            'activity': '全天培训：高情商领导力——TGO 广州 8 月分会活动_2022',
            'expend': '￥22,913.07',
            'link': 'https://tgo.infoq.cn/event/574'
          },
          {
            'time': '2022年9月25日',
            'activity': 'GTLC 技术领导力大会 广州站_2022',
            'expend': '￥65,750.08',
            'link': 'https://gtlc.infoq.cn/2022/guangzhou/'
          },
          {
            'time': '/',
            'activity': 'TGO 广州分会十全十美小组费用_2022',
            'expend': '￥10,000',
            'link': '/'
          },
          {
            'time': '/',
            'activity': 'TGO 广州分会兴趣小组费用_2022',
            'expend': '￥1,280',
            'link': '/'
          },
          {
            'time': '/',
            'activity': 'TGO 广州分会董事会费用_2022',
            'expend': '￥6,593',
            'link': '/'
          },
          {
            'time': '/',
            'activity': 'TGO 广州分会日常费用_2022',
            'expend': '￥38,137.3',
            'link': '/'
          }
        ]
      }
    }
  }
}
